import React from "react";
import { ErrorBoundary } from "../../../components/ui";
import CharacterKnowledgeContent from "../../../components/knowledge/CharacterKnowledgeContent";
import type { CampaignView } from "../../../types/types";

interface CampaignKnowledgeViewProps {
  campaign: CampaignView;
}

/**
 * Full-page Knowledge tab — Surface 1 of the Character Knowledge View feature.
 *
 * Shows a character-filtered asset tree on the left and a read-only asset detail
 * panel on the right. Campaign members see only the assets accessible to their
 * selected character; the DM sees the full unfiltered tree.
 */
const CampaignKnowledgeView: React.FC<CampaignKnowledgeViewProps> = ({ campaign }) => {
  return (
    <ErrorBoundary errorMessage="Failed to render the knowledge view.">
      <div className="-mx-6 -mb-6 overflow-hidden">
        <CharacterKnowledgeContent
          campaignId={campaign.id}
          mode="full"
          campaignCreatedBy={campaign.createdBy}
        />
      </div>
    </ErrorBoundary>
  );
};

export default CampaignKnowledgeView;
